import * as tslib_1 from "tslib";
import { AuthenticationService } from '@core/authentication/authentication.service';
import { Subject } from 'rxjs';
import io from 'socket.io-client';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../authentication/authentication.service";
var SocketService = /** @class */ (function () {
    function SocketService(authenticationService) {
        var _this = this;
        this.authenticationService = authenticationService;
        this.realtimeNotification$ = new Subject();
        this.socket = io(environment.REALTIME_URL, { autoConnect: false });
        this.socket.on('reconnect_attempt', function () { return _this.updateToken(); });
        this.socket.on('connect', function () { return console.warn('connect done'); });
        this.socket.on('disconnect', function () { return console.warn('disconnect done'); });
        this.socket.on('enterprise-notification', function (_a) {
            var message = _a.message;
            _this.realtimeNotification$.next(message);
        });
    }
    Object.defineProperty(SocketService.prototype, "lastNotificationObs", {
        get: function () {
            return this.realtimeNotification$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    SocketService.prototype.disconnect = function () {
        this.socket.disconnect();
    };
    SocketService.prototype.connect = function () {
        this.updateToken();
        this.socket.connect();
    };
    SocketService.prototype.reconnect = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.disconnect();
                this.connect();
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(SocketService.prototype, "token", {
        get: function () {
            return this.authenticationService.accessToken || '';
        },
        enumerable: true,
        configurable: true
    });
    SocketService.prototype.updateToken = function () {
        this.socket.io.opts.query = {
            token: this.token
        };
    };
    SocketService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SocketService_Factory() { return new SocketService(i0.ɵɵinject(i1.AuthenticationService)); }, token: SocketService, providedIn: "root" });
    return SocketService;
}());
export { SocketService };
